import { PortfolioRepo } from "@services/portfolio.repo";
import { isNullOrUndefined } from "util";
import { IS_RECONCILED_FLAG } from "@constants/reporting";
import { extractErrorMessage } from "@common/utils/errorUtils";

class YearlyTransactionDialogController {
  public transaction: any = {};
  public allPortfolios: any;

  public transactionForm: ng.IFormController;
  public currencyList: Array<string>;
  public portfolio: any;
  public type: any;
  public client: any;
  //public clientConfig: ClientDetails;
  public month: any;
  public edit: any;
  public fullEdit: any;
  public isReconciled: boolean;
  public isLoading: boolean = false;
  //private clientRepo: ClientRepo;

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService,
    private portfolioRepo: PortfolioRepo,
    private notifyjs
  ) {}

  $onInit() {
    if (this.transaction) {
      this.transaction.additions = this.transaction.totalCreditAmount;
      this.transaction.withdrawels = this.transaction.totalDebitAmount;
      this.transaction.ytdPerformance = this.transaction.performance;
      this.transaction.transactionDate = this.transaction.performanceDate;
      this.transaction.activeMonths = this.transaction.monthsInYear;
    }
    if (this.edit == true && this.transaction.manualInput == true) {
      this.fullEdit = false;
    } else if (this.edit == false) {
      this.fullEdit = false;
    } else {
      this.fullEdit = true;
    }
    this.currencyList = ["MUR", "EUR", "GBP", "USD", "CHF"];
    this.isReconciled = sessionStorage.getItem(IS_RECONCILED_FLAG) === "true";
  }

  save() {
    // console.log(this.type);
    this.isLoading = true;
    if (this.type === "single") {
      let performanceObj = {
        id: this.transaction.id,
        performanceDate: this.transaction.transactionDate,
        currency: this.transaction.currency,
        portfolioId: this.portfolio.portfolioId,
        locality: this.portfolio.displayLocal ? 0 : 1,
        openingBalance: this.transaction.openingBalance,
        closingBalance: this.transaction.closingBalance,
        totalDebitAmount: this.transaction.withdrawels,
        totalCreditAmount: this.transaction.additions,
        ytdPerformance: parseFloat(this.transaction.ytdPerformance),
        benchmarkPerformance: this.transaction.benchmarkPerformance,
        benchmarkPerformanceSecondary:
          this.transaction.benchmarkPerformanceSecondary,
      };
      this.portfolioRepo
        .insertYearlyPerformance(performanceObj, this.isReconciled)
        .then(() => {
          this.$mdDialog.hide();
        })
        .catch((err) => this.notifyjs(extractErrorMessage(err)))
        .finally(() => {
          this.isLoading = false;
        });
    } else {
      let performanceObj = {
        id: this.transaction.id,
        performanceDate: this.transaction.transactionDate,
        currency: this.transaction.currency,
        clientId: this.client.id,
        openingBalance: this.transaction.openingBalance,
        closingBalance: this.transaction.closingBalance,
        totalDebitAmount: this.transaction.withdrawels,
        totalCreditAmount: this.transaction.additions,
        ytdPerformance: parseFloat(this.transaction.ytdPerformance),
        activeMonths: this.transaction.activeMonths,
        locality: this.transaction.locality,
        benchmarkPerformance: this.transaction.benchmarkPerformance,
        benchmarkPerformanceSecondary:
          this.transaction.benchmarkPerformanceSecondary,
      };
      if (this.month == true) {
        performanceObj.activeMonths = 1;
        performanceObj["portfolios"] = this.allPortfolios;
        this.portfolioRepo
          .insertCombinedMonthlyPerformance(performanceObj, this.isReconciled)
          .then(() => {
            this.$mdDialog.hide();
          })
          .catch((err) => this.notifyjs(extractErrorMessage(err)))
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        performanceObj["portfolios"] = this.allPortfolios;
        this.portfolioRepo
          .insertCombinedPerformance(performanceObj, this.isReconciled)
          .then(() => {
            this.$mdDialog.hide();
          })
          .catch((err) => this.notifyjs(extractErrorMessage(err)))
          .finally(() => {
            this.isLoading = false;
          });
      }
    }
  }

  cancel() {
    this.$mdDialog.hide();
  }

  roundAmounts(type) {
    if (!isNullOrUndefined(this.transaction[type])) {
      this.transactionForm[type].$viewValue =
        +this.transactionForm[type].$viewValue;
      this.transactionForm[type].$viewValue =
        this.transactionForm[type].$viewValue.toFixed(2);
      this.transaction[type] = +this.transaction[type].toFixed(2);
    }
  }
}


export const yearlyTransactionDialog: angular.IComponentOptions = {
  template: require("./yearlyTransaction.dialog.html"),
  controller: YearlyTransactionDialogController,
  bindings: {
    portfolio: "<",
    transaction: "<",
    type: "<",
    client: "<",
    month: "<",
    allPortfolios: "<",
    edit: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/performanceManagement/yearlyTransactionDialog/yearlyTransaction.dialog.ts